export const PageHeader = ({ eyebrow, title, subtitle, children, testid = "page-header" }) => (
  <section className="relative bg-white border-b border-[#E2E8F0] overflow-hidden" data-testid={testid}>
    <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#63D8C4]/20 blur-3xl" aria-hidden />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16 fade-up">
      {children}
      {eyebrow && <p className="eyebrow mt-4">{eyebrow}</p>}
      <h1 className="mt-2 text-3xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#0B2150]">{title}</h1>
      {subtitle && <p className="mt-3 sm:mt-4 max-w-2xl text-sm sm:text-base md:text-lg text-[#475569] leading-relaxed">{subtitle}</p>}
    </div>
  </section>
);
